export const appInfo = {
  name: "CODRMS",
  name2: "Result Management",
};
